const sundays = [
  ["May 24", "*Belleville*", "6am - 12pm"],
  ["May 31", "Whitmore", "6am - 12pm"],
  ["June 7", "Chemung", "6am - 12pm"],
  ["June 14", "Woodland", "6am - 12pm"],
  ["June 21", "Sand", "6am - 12pm"],
  ["June 28", "Ford", "6am - 12pm"],
  ["July 12", "*Belleville*", "6am - 12pm"],
  ["July 19", "Devils", "6am - 12pm"],
  ["July 26", "Woodland", "6am - 12pm"],
  ["Aug 2", "Whitmore", "6am - 12pm"],
  ["Aug 9", "Wamplers", "7am - 1pm"],
  ["Aug 16", "Chemung", "6am - 12pm"],
  ["Aug 23", "Halfmoon", "7am - 1pm"],
  ["Sept 13", "Classic - Ford Lake", "7am - 1pm"]
];

const sundaysWithWinners = [
  ["May 24", "*Belleville*", "6am - 12pm", "Andrew/Randy (13.39)"],
  ["May 31", "Whitmore", "6am - 12pm", "Bill/Will (14.57)"],
  ["June 7", "Chemung", "6am - 12pm", "Broc/Jared (15.65)"],
  ["June 14", "Woodland", "6am - 12pm", "Jon (18.61)"],
  ["June 21", "Sand", "6am - 12pm", "Jon (15.24)"],
  ["June 28", "Ford", "6am - 12pm", "Gary (14.01)"],
  ["July 12", "*Belleville*", "6am - 12pm", "Nick/Austin (14.16)"],
  ["July 19", "Devils", "6am - 12pm", "Jimmy (14.02)"],
  ["July 26", "Woodland", "6am - 12pm", "Jimmy (18.30)"],
  ["Aug 2", "Whitmore", "6am - 12pm", "Jon (15.57)"],
  ["Aug 9", "Wamplers", "7am - 1pm", "Marty/Terry (13.84)"],
  ["Aug 16", "Chemung", "6am - 12pm", "Jon (16.33)"],
  ["Aug 23", "Halfmoon", "7am - 1pm", "Jimmy (15.30)"],
  ["Sept 13", "Classic - Ford Lake", "7am - 1pm", "Bill/Will (16.01)"]
];

const sundayTopFive = [
  ["Jon - 2026 AOY", "83"],
  ["Jimmy", "75"],
  ["Marty/Terry", "65"],
  ["Andrew/Randy", "59"],
  ["Aaron/Michael", "58"]
];

const sundayBigBass = [
  ["Jon", "6.28"],
];


export {
  sundays,
  sundaysWithWinners,
  sundayTopFive,
  sundayBigBass,
}